import React from 'react';
import { BookOpen, ClipboardList, CheckCircle, Users, FileText, Flame, Layers, Edit3, GraduationCap, Home, RefreshCw, ChevronLeft, ChevronRight, Share, Bookmark, Tabs } from 'lucide-react';
import SchoolGoat from '../assets/schoolgoat.webp';
import { getRandomNumberBetween } from './visUtils';
import { BrowserFooter, Vis_Header, Vis_Container } from './visComponents';
import { CURRENT_USER_TYPE } from './visComponents';

const USER_TYPES = { 
  high: {
    percentile: getRandomNumberBetween(85, 99),
    notesTakenHours: getRandomNumberBetween(150, 900),
    flashcardsMastered: getRandomNumberBetween(2000, 10000),
    practiceQuestionsCompleted: getRandomNumberBetween(2000, 10000),
    classMaterialsLearned: getRandomNumberBetween(50, 500),
    essaysWritten: getRandomNumberBetween(5, 30),
    tutoringSessions: getRandomNumberBetween(20, 100),
    studyGuidesWritten: getRandomNumberBetween(20, 100),
  },
  medium: {
    percentile: getRandomNumberBetween(50, 84),
    notesTakenHours: getRandomNumberBetween(50, 100),
    flashcardsMastered: getRandomNumberBetween(200, 700),
    practiceQuestionsCompleted: getRandomNumberBetween(200, 700),
    classMaterialsLearned: getRandomNumberBetween(10, 20),
    essaysWritten: getRandomNumberBetween(2, 5),
    tutoringSessions: getRandomNumberBetween(5, 15),
    studyGuidesWritten: getRandomNumberBetween(5, 15),
  },
  low: {
    percentile: getRandomNumberBetween(0, 49),
    notesTakenHours: getRandomNumberBetween(0, 50),
    flashcardsMastered: getRandomNumberBetween(0, 200),
    practiceQuestionsCompleted: getRandomNumberBetween(0, 200),
    classMaterialsLearned: getRandomNumberBetween(0, 15),
    essaysWritten: getRandomNumberBetween(0, 2),
    tutoringSessions: getRandomNumberBetween(0, 3),
    studyGuidesWritten: getRandomNumberBetween(0, 4),
  }
}

const getNumberSuffix = (number) => {
  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;
  
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return 'th';
  }

  switch (lastDigit) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}


const VisualScreen3 = () => {
  const studentMetrics = USER_TYPES[CURRENT_USER_TYPE]

  const metricData = [
    { metric: "In-Class Notes", subheader: "hours of notes taken", value: studentMetrics.notesTakenHours, icon: <BookOpen /> },
    { metric: "Class Materials", subheader: "# of materials analyzed", value: studentMetrics.classMaterialsLearned, icon: <Layers /> },
    { metric: "Practice tests", subheader: "# of questions completed", value: studentMetrics.practiceQuestionsCompleted, icon: <CheckCircle /> },
    { metric: "Flashcards", subheader: "# of cards memorized", value: studentMetrics.flashcardsMastered, icon: <ClipboardList /> },
    { metric: "Study Guides", subheader: "# of guides created", value: studentMetrics.studyGuidesWritten, icon: <FileText /> },
    { metric: "Tutoring", subheader: "# of tutoring sessions", value: studentMetrics.tutoringSessions, icon: <GraduationCap /> },
    // { metric: "Essays", subheader: "# of essays improved", value: studentMetrics.essaysWritten, icon: <Edit3 /> },
  ];

  return (

    <Vis_Container>
     
      <Vis_Header title="Study Achievements" />

        {/* Percentile component */}
        <div style={{ padding: '1.5rem', background: 'rgb(238, 242, 255)', textAlign: 'center', margin: "0 0rem", borderRadius: "0.5rem" }}>
          <div style={{ fontSize: '4rem', fontWeight: 'bold', color: 'rgb(67, 56, 202)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {studentMetrics.percentile}
            <Flame style={{ marginLeft: '0.75rem', color: 'rgb(249, 115, 22)' }} size={56} />
          </div>
          <div style={{ fontSize: '1.25rem', color: 'rgb(99, 102, 241)', fontWeight: '600', marginTop: '0.75rem' }}>
            You are in the <span style={{ background: 'rgb(209, 219, 255)', padding: '0.3rem 0.6rem', borderRadius: '0.375rem', fontWeight: '700' }}>{studentMetrics.percentile}{getNumberSuffix(studentMetrics.percentile)}</span> percentile of students
          </div>
        </div>
        

        <div style={{ padding: '1.5rem', display: 'flex', flexWrap: 'wrap', gap: '1.5rem',   }}>
          {metricData.map((item, index) => (
            <div key={index} style={{ flex: '1 1 calc(50% - 1rem)', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '1.5rem', paddingTop: "2rem", paddingBottom: "2rem", borderRadius: '0.75rem', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', border: '1px solid #e5e7eb' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.85rem' }}>
                <div style={{ fontSize: '1rem', fontWeight: '600', color: 'rgb(31, 41, 55)' }}>{item.metric}</div>
                <div>
                  {React.cloneElement(item.icon, { size: 16, color: 'rgb(31, 41, 55)' })}
                </div>
              </div>
              <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'rgb(31, 41, 55)', marginBottom: '0.5rem' }}>{item.value.toLocaleString()}</div>
              <div style={{ fontSize: '0.875rem', color: 'rgb(107, 114, 128)' }}>{item.subheader}</div>
            </div>
          ))}
        </div>



      <BrowserFooter />

    </Vis_Container>
  );
};

export default VisualScreen3;






                {/* Metric cards */}
                {/* <div style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {metricData.map((item, index) => (
            <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.5rem', borderRadius: '0.75rem', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', border: '1px solid #e5e7eb' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div>
                  {React.cloneElement(item.icon, { size: 18, color: 'rgb(31, 41, 55)' })}
                </div>
                <div style={{ fontSize: '1.2rem', fontWeight: '600', color: 'rgb(31, 41, 55)', marginTop: '0.5rem' }}>{item.metric}</div>
                <div style={{ fontSize: '0.875rem', color: 'rgb(107, 114, 128)', marginTop: '0.5rem' }}>{item.subheader}</div>
              </div>
              <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'rgb(31, 41, 55)' }}>{item.value.toLocaleString()}</div>
            </div>
          ))}
        </div> */}